import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    border: '1px solid #F0F0F0',
    borderRadius: '7px',
    boxSizing: 'border-box',
    boxShadow:
      '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
    width: 500,
    height: 300,
    padding: 12,
    background: 'white',
    overflow: 'auto',

    '& .text__control': {
      height: '100% !important'
    },

    '& .text__highlighter': {
      height: '100% !important'
    }
  }
}))

export default useStyles
